import { GenericBackendResponse } from '../genericBackendResponse';

export enum RequiredEmployeeField {
	GROSS_ANNUAL_SALARY = 'GROSS_ANNUAL_SALARY',
	EMPLOYMENT_START_DATE = 'EMPLOYMENT_START_DATE',
	CATEGORY = 'CATEGORY',
	COLLECTIVE_AGREEMENT_GROUP = 'COLLECTIVE_AGREEMENT_GROUP'
}

export enum EnrollmentType {
	DIRECT = 'DIRECT',
	PENDING_ACCEPTANCE = 'PENDING_ACCEPTANCE'
}

export interface EmployeeInviteRequirements {
	enrollmentType: EnrollmentType;
	requiredFields: RequiredEmployeeField[];
}

const getEmployeeInviteRequirements = async (
	token: string,
	companyId: string
): Promise<GenericBackendResponse<EmployeeInviteRequirements>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/${companyId}/employee-invite-requirements`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	return response.json();
};

export default getEmployeeInviteRequirements;
